import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../../ooh/services/carto.helper'
import {
  fetchCompareAggregations,
  type CompareAggregationsFilters,
} from '../services/compare-aggregations.service'

export {
  type CompareAggregationRow,
  type CompareAggregationsFilters,
} from '../services/compare-aggregations.service'

export function injectCompareAggregationsQuery(
  filters: Signal<CompareAggregationsFilters>,
) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => {
    const f = filters()
    return {
      queryKey: ['compare-aggregations', f],
      queryFn: async ({ signal }) => {
        return fetchCompareAggregations(cartoClient, f, signal)
      },
      enabled: f.delivery_id_1 > 0 && f.delivery_id_2 > 0,
    }
  })
}
